// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// Vue.component(Header.name, Header)
// Vue.component(Navbar.name, Navbar)
// Vue.component(TabItem.name, TabItem)
import { i18n } from '@/assets/languages'
import Header from '@/components/Header.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Mint, { MessageBox, Toast } from 'mint-ui'
// import {
//   Header,
//   Navbar,
//   TabItem
// } from 'mint-ui'
import 'mint-ui/lib/style.css'
import Vue from 'vue'

import App from './App'
import router from './router/mcn'
import store from './store'
import { handleNum } from './utils/qmis'
// 全局注册Bus
import Bus from './utils/vbus'

Vue.$toast = Vue.prototype.$toast = Toast
Vue.$messagebox = Vue.prototype.$messagebox = MessageBox
Vue.$handleNum = Vue.prototype.$handleNum = handleNum
// 弹出框后面页面禁止滑动
Vue.prototype.$stopScroll = function (val) {
  if (val) {
    document.documentElement.style.overflow = 'hidden'
  } else {
    document.documentElement.style.overflow = 'scroll'
  }
}

Vue.use(Mint)
Vue.use(ElementUI)
// 注册为全局组件
Vue.component('AppHeader', Header)
Vue.use(Bus)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  console.log(to)
  console.log(from)
  if (!store.state.role) {
    store.dispatch('setRole', 'mcn')
  }
  Vue.prototype.$stopScroll()
  if (to.query && to.query.inviteCode) {
    localStorage.setItem('inviteCode', to.query.inviteCode)
    if (to.query.inviteNft) {
      localStorage.setItem('inviteNft', to.query.inviteNft)
    } else {
      localStorage.removeItem('inviteNft')
    }
    if (to.query.inviteAct) {
      localStorage.setItem('inviteAct', to.query.inviteAct)
    } else {
      localStorage.removeItem('inviteAct')
    }
  }
  next()
})

router.afterEach((to, from, nex) => {
  if (store.state.keepAlive.indexOf(to.name) < 0) {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
})

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main_mcn.js